import React from "react";

import AboutUs from "./AboutUs";
import Products from "./Products";
import Certificates from "./Certificates";
import Clients from "./Clients";
import Contact from "./Contact";
import Navbar from "./Navbar";
import { Container } from "@mui/material";

const App = () => {
  return (
    <>
      <Navbar />
      <Container>
        <AboutUs />
        <Products />
        <Certificates />
      </Container>
      <Clients />
      <Contact />
    </>
  );
};

export default App;
